import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const addRegion = createAsyncThunk('region/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/admin/region/create-region`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editRegion = createAsyncThunk('region/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/region/update-region/${data?.region_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteRegion = createAsyncThunk('region/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/admin/region/delete-region/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllRegion = createAsyncThunk('region/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/region/get-all-region`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRegionByID = createAsyncThunk('region/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/region/get-region/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllDetailsOfRegion = createAsyncThunk('region/get-all-details-of-region', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/region/get-all-details-of-region/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const updateRegionDetails = createAsyncThunk('region/update-region-details', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/admin/region/update-region-details/${data?.region_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const selectCleanerRegion = createAsyncThunk('region/select-cleaner-region', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/admin/cleaner/${data.id}/select-region`, { region_id: data.regionId })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allRegion: [],
  getRegion: null,
  getDetailsByRegion:null,
  region: null,
  error: null
}

const regionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.user = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addRegion.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addRegion.fulfilled, (state, action) => {
        state.isLoading = false
        state.region = action.payload?.data?.data
      })
      .addCase(addRegion.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editRegion.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editRegion.fulfilled, (state, action) => {
        state.isLoading = false
        state.region = action.payload?.data?.data
      })
      .addCase(editRegion.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deleteRegion.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteRegion.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteRegion.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllRegion.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllRegion.fulfilled, (state, action) => {
        state.isLoading = false
        state.allRegion = action.payload?.data?.data
      })
      .addCase(getAllRegion.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getRegionByID.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRegionByID.fulfilled, (state, action) => {
        state.isLoading = false
        state.getRegion = action.payload?.data?.data
      })
      .addCase(getRegionByID.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllDetailsOfRegion.pending, (state) => {
        state.isLoading = true
        state.getDetailsByRegion = []
      })
      .addCase(getAllDetailsOfRegion.fulfilled, (state, action) => {
        state.isLoading = false
        state.getDetailsByRegion = action.payload?.data?.data
      })
      .addCase(getAllDetailsOfRegion.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(updateRegionDetails.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateRegionDetails.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(updateRegionDetails.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(selectCleanerRegion.pending, (state) => {
        state.isLoading = true
      })
      .addCase(selectCleanerRegion.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(selectCleanerRegion.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = regionSlice.actions
export default regionSlice.reducer
